module.exports = __webpack_public_path__ + "static/img/jigou-xibu-top.7c5ea8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-xibu-top.png
// module id = 6/O7
// module chunks = 2